module.exports = __webpack_public_path__ + "img/d3d40bb.svg";